module.exports = __webpack_public_path__ + "assets/img/user-2.fe4eecb7.jpg";